import styled from "styled-components"
import { theme } from "Theme"

const SectionHeadingButton = styled.div`
  margin: 0;
  text-decoration: none;
  text-align: center;
  align-self: initial;
  display: inline-block;
  margin-top: 1rem;
  a + button {
    margin-left: 12px;
  }
  @media (min-width: ${theme.breakpoints.s}) {
    display: flex;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
    align-self: center;
    margin: 0;
  }
`

export default SectionHeadingButton
